export class UpdateContract {
  static readonly type = '[Contract.Contract] Update';
  constructor(public contract: any) {}
}

export class AddLocationPointer {
  static readonly type = '[Contract.Contract] Add Contract Location Pointer';
  constructor(public locID: string) {}
}

export class RemoveLocationPointer {
  static readonly type = '[Contract.Contract] Remove Contract Location Pointer';
  constructor(public locID: string) {}
}

export class AddNamePointer {
  static readonly type = '[Contract.Contract] Add Contract Name Pointer';
  constructor(public nameID: string) {}
}

export class RemoveNamePointer {
  static readonly type = '[Contract.Contract] Remove Contract Name Pointer';
  constructor(public nameID: string) {}
}

export class AddConditionPointer {
  static readonly type = '[Contract.Contract] Add Contract Condition Pointer';
  constructor(public conditionID: string) {}
}

export class RemoveConditionPointer {
  static readonly type = '[Contract.Contract] Remove Contract Condition Pointer';
  constructor(public conditionID: string) {}
}

export class AddTeamMemberPointer {
  static readonly type = '[Contract.Contract] Add Team Member Pointer';
  constructor(public partyID: string) {}
}

export class RemoveTeamMemberPointer {
  static readonly type = '[Contract.Contract] Remove Team Member Pointer';
  constructor(public partyID: string) {}
}

export class AddAttachmentPointer {
  static readonly type = '[Contract.Contract] Add Contract Attachment Pointer';
  constructor(public attachmentID: string) {}
}

export class RemoveAttachmentPointer {
  static readonly type = '[Contract.Contract] Remove Contract Attachment Pointer';
  constructor(public attachmentID: string) {}
}

export class AddLinePointer {
  static readonly type = '[Contract.Contract] Add Contract Line Poiner';
  constructor(public lineID: string) {}
}

export class RemoveLinePointer {
  static readonly type = '[Contract.Contract] Remove Contract Line Poiner';
  constructor(public lineID: string) {}
}

export class AddContractInterestPointer {
  static readonly type = '[Contract.Contract] Add Contract Interest Pointer';
  constructor(public interestID: string) {}
}

export class RemoveContractInterestPointer {
  static readonly type = '[Contract.Contract] Remove Contract Interest Pointer';
  constructor(public interestID: string) {}
}

export class AddProfilePointer {
  static readonly type = '[Contract.Contract] Add Contract Profile Pointer';
  constructor(public profileID: string) {}
}

export class RemoveProfilePointer {
  static readonly type = '[Contract.Contract] Remove Contract Profile Pointer';
  constructor(public profileID: string) {}
}

export class SetBillToEntity {
  static readonly type = '[Contract.Contract] Set Bill To Entity';
  constructor(public entity: any, public roleType: string) {}
}

export class SyncContractBroker {
  static readonly type = '[Contract.Contract] Sync Contract Broker';
  constructor(public broker: any) {}
}

export class SyncContractBrokerAffiliate {
  static readonly type = '[Contract.Contract] Sync Contract Broker Affiliate';
  constructor(public brokerAffiliate: any) {}
}

export class AddPriorHistoryPointer {
  static readonly type = '[Contract.Contract] Add Prior History Pointer';
  constructor(public PriorHistoryID: string) {}
}

export class RemovePriorHistoryPointer {
  static readonly type = '[Contract.Contract] Remove Prior History Pointer';
  constructor(public PriorHistoryID: string) {}
}

export class SyncContractNumber {
  static readonly type = '[Contract.Contract] Sync Contract Number';
  constructor(public contractNumber: string) {}
}
